import {actions as A} from '../../constants/actions';

const showProgressBarPopUp = (message) => {
  return (dispatch) => {
    dispatch({
      type: A.SHOW_PROGRESS_BAR_POP_UP,
      payload: {message}
    });
  }
};

export {showProgressBarPopUp}